// extracted by mini-css-extract-plugin
export var columnItem = "_4g-3";
export var columnItemDraggable = "_4g-4";
export var dragHandle = "_4g-0";
export var dragHandleHovered = "_4g-1";
export var dropdown = "_4g-5";
export var dropdownContent = "_4g-7";
export var dropdownInner = "_4g-6";
export var filterDropdownHeader = "_4g-8";
export var icon = "_4g-2";
export var sectionDivider = "_4g-9";